import React from 'react';
import { credibilityLine, sectors } from '../data/site';
export function CredibilityStrip() {
  return <section aria-label="Credentials" className="w-full border-y border-cream/12 bg-navy py-7 sm:py-8" data-id="element-56" data-mp="20b1w8ucba582">
      <div className="mx-auto flex max-w-[960px] flex-col gap-5 px-5 sm:px-8" data-id="element-57" data-mp="1vjabj0fu6tpu">
        <p className="font-sans text-[10px] font-medium uppercase tracking-label text-cream/50 sm:text-[11px]" data-id="element-58" data-mp="1rjt4i2krhoik">
          {credibilityLine}
        </p>
        <ul className="flex flex-wrap items-center gap-x-8 gap-y-3" data-id="element-59" data-mp="1mhkcb8fpqqhi">
          {sectors.map(sector => <li key={sector} className="font-sans text-[10px] uppercase tracking-label text-cream/35" data-id="element-60" data-mp="1clr39z17df4h">
              {sector}
            </li>)}
        </ul>
      </div>
    </section>;
}